/* Match paint options by their stable colour code or their displayed name. */
(function (root, factory) {
  const rules = factory();
  if (typeof module === 'object' && module.exports) module.exports = rules;
  else root.FairfColourRules = rules;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const key = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f\s]/g, '').toLowerCase();
  function matchingColour(paint, name, code) {
    const wanted = [name, code].filter(Boolean).map(key);
    return paint?.options?.find(option => option.name === 'Kleur')?.values?.find(value =>
      [value.name, value.code].filter(Boolean).some(candidate => wanted.includes(key(candidate)))
    );
  }
  function showPaint({ handle, paint, current, fromColour, name, code }) {
    if (handle === current) return true;
    if (fromColour && paint?.fixedColour) return false;
    if (handle === 'muurverf-extra-dekkend') return Boolean(matchingColour(paint, name, code));
    return true;
  }
  return { matchingColour, showPaint };
});
